/*
 * ===============================================================================================================
 *                                Copyright 2024, Blue Yonder Group, Inc.
 *                                           All Rights Reserved
 *
 *                               THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF
 *                                          BLUE YONDER GROUP, INC.
 *
 *
 *                         The copyright notice above does not evidence any actual
 *                                 or intended publication of such source code.
 *
 * ===============================================================================================================
 */

const MESSAGES = {
  DELETE_MODULE_TITLE: "Are you sure you want to delete the Module ",
  MODULE_EMPTY_SCREEN_TITLE: "No Module to display",
  MODULE_ADD_BUTTON: "Add Module",
  SELECT_MODULE: "Select Module",
  NO_RESULTS_FOUND: "No Results Found",
};

const TITLES = {
  EDIT: "Edit",
  CLONE: "Clone",
  CANCEL: "Cancel",
  DELETE: "Delete",
  MODULE_LIST: "Module List",
  MODULES: "Modules",
  MODULE_NAME: "Module Name",
  ADD_MODULE: "Add Module",

};

export { TITLES, MESSAGES };
